export default __webpack_public_path__ + "static/media/wooden-chair.c4d25afe.png";